// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProductQuantity_layout__DEtSp {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
  margin-top: 16px;
}
.ProductQuantity_layout__DEtSp .ProductQuantity_input-box__cDhoP {
  flex-grow: 1;
  height: 40px;
  border: solid 1px #e9e9e9;
  border-radius: 4px;
  padding: 10px;
  background-color: #ffffff;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.ProductQuantity_layout__DEtSp .ProductQuantity_input-box__cDhoP .ProductQuantity_unit__PpbJ\\+ {
  background-color: #ebf3ff;
  width: -moz-fit-content;
  width: fit-content;
  color: #252525;
  line-height: 20px;
  font-size: 12px;
  padding: 4px 16px;
  border-radius: 16px;
  font-weight: 600;
}
.ProductQuantity_layout__DEtSp .ProductQuantity_input-box__cDhoP .ProductQuantity_disable__1oPdo {
  background-color: #e9e9e9;
  color: #bbbbbb;
}
.ProductQuantity_layout__DEtSp Button {
  padding: 11px;
}
.ProductQuantity_layout__DEtSp .ProductQuantity_back-icon__ZgNbX {
  font-size: 16px;
}

.ProductQuantity_quantity-container__GWQF1 {
  font-size: 16px;
}
.ProductQuantity_quantity-container__GWQF1 .ProductQuantity_quantity-title__IBO7S {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 4px;
}
.ProductQuantity_quantity-container__GWQF1 .ProductQuantity_quantity-title-disabled__oghvm {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 4px;
  color: #b3b3b3;
}
.ProductQuantity_quantity-container__GWQF1 .ProductQuantity_quantity-label-disabled__Sv7\\+k {
  color: #b3b3b3;
}`, "",{"version":3,"sources":["webpack://./src/views/ProductDetailView/ProductPrice/ProductQuantity/ProductQuantity.module.scss","webpack://./src/styles/_colors.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAFF;AAGE;EACE,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,yBCNI;EDOJ,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AADJ;AAEI;EACE,yBCZO;EDaP,uBAAA;EAAA,kBAAA;EACA,cCvBQ;EDwBR,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBErBM;AFqBZ;AAEI;EACE,yBCjBkB;EDkBlB,cCJQ;ADId;AAGE;EACE,aAAA;AADJ;AAIE;EACE,eEvCK;AFqCT;;AAMA;EACE,eE5CO;AFyCT;AAKE;EACE,eE7CO;EF8CP,iBE3CG;EF4CH,kBAAA;AAHJ;AAKE;EACE,eElDO;EFmDP,iBEhDG;EFiDH,kBAAA;EACA,cAAA;AAHJ;AAKE;EACE,cAAA;AAHJ","sourcesContent":["@use \"styles/typography\";\n@use \"styles/colors\";\n\n.layout {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 4px;\n  margin-top: 16px;\n  .input-box {\n    flex-grow: 1;\n    height: 40px;\n    border: solid 1px colors.$color-button-disabled;\n    border-radius: 4px;\n    padding: 10px;\n    background-color: colors.$white;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    .unit {\n      background-color: colors.$light-blue;\n      width: fit-content;\n      color: colors.$neutral-700;\n      line-height: 20px;\n      font-size: 12px;\n      padding: 4px 16px;\n      border-radius: 16px;\n      font-weight: typography.$semi-bold;\n    }\n    .disable {\n      background-color: colors.$color-button-disabled;\n      color: colors.$neutral-400;\n    }\n  }\n  Button {\n    padding: 11px;\n  }\n\n  .back-icon {\n    font-size: typography.$body-l;\n  }\n}\n\n.quantity-container {\n  font-size: typography.$body-l;\n\n  .quantity-title {\n    font-size: typography.$header-s;\n    font-weight: typography.$bold;\n    margin-bottom: 4px;\n  }\n  .quantity-title-disabled {\n    font-size: typography.$header-s;\n    font-weight: typography.$bold;\n    margin-bottom: 4px;\n    color: #b3b3b3;\n  }\n  .quantity-label-disabled {\n    color: #b3b3b3;\n  }\n}\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `ProductQuantity_layout__DEtSp`,
	"input-box": `ProductQuantity_input-box__cDhoP`,
	"unit": `ProductQuantity_unit__PpbJ+`,
	"disable": `ProductQuantity_disable__1oPdo`,
	"back-icon": `ProductQuantity_back-icon__ZgNbX`,
	"quantity-container": `ProductQuantity_quantity-container__GWQF1`,
	"quantity-title": `ProductQuantity_quantity-title__IBO7S`,
	"quantity-title-disabled": `ProductQuantity_quantity-title-disabled__oghvm`,
	"quantity-label-disabled": `ProductQuantity_quantity-label-disabled__Sv7+k`
};
export default ___CSS_LOADER_EXPORT___;
